module.exports = global["moment"] = require("-!/var/www/html/node_modules/moment/moment.js");


//////////////////
// WEBPACK FOOTER
// ./~/moment/moment.js
// module id = 105
// module chunks = 1